

export const frontMatter = {};
export const contentTitle = undefined;



import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Naše selo",
  "id": "naše-selo",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    h3: "h3",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      id: "naše-selo",
      children: "Naše selo"
    }), "\n", _jsx(_components.p, {
      children: "Iz vse možlive města, kde žijut ljudi, ja naj-mnogo ljubim male selo, daleko od šumny grad, s jego mala společnost. Ono ne ima prěpolnjene bloki, jedino male drevenne domki. Jest to proste i malovatelne město dlja žitje, s žiteli, čije lica sut ravno znane kak cvěti v naš sad. To jest zatvorjeny svět s nemnogo ljudi, blizko sjedinjene kak mravki v mravska kopa, pčeli v pčelnik, ovci v ovčarnija, mniški v konvent, ili morniki na korabja – kde vsekto zna vsekogo i vsekto jest znany od vsekogo, kde vsekto interesova se v vsekogo i vsekto može imati nadeja, že nekto interesova se v jego."
    }), "\n", _jsx(_components.p, {
      children: "Kak milo bylo by zanuriti se v to srdečne čutje od ljubjenje i neznane običaji, sobrati se i byti prijatelji s te vse jedinstvene ljudi okolo nas! Tako, že my budemo znati vse zakutki i povrati od tenke ulici i solnečne luki, ktore my prohodimo vsaki denj. Mala socialna grupa, ktora jest selska společnost, jest to, za čto poezija i proza blagodarijut naj-mnogo. Dolga, raztegnjena draga, ktora bludi se v mily, teply denj i prěhodi črěz velika, široka draga, polna od avta i tiri. Vy hočete putovati s mene, dragi čitatelj? Put ne bude dolgy. My načinamo na dolina konec i odtudy my budemo pohoditi v vrh."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

